// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__NvLrA","loaderBox":"loader_loaderBox__pGA-2","loader":"loader_loader__FSGKb"};